// Sammel-Route für alle /finanzberatung-<stadt> Seiten.
//
// Die einzelnen Stadtseiten bleiben als eigene Dateien bestehen (Prerender
// leitet die Routenliste weiterhin aus den Dateinamen ab) — sie werden hier
// nur gebündelt eingebunden, damit im Router genau EIN Eintrag steht statt
// über 100. Rein organisatorisch, das Rendering ist identisch.

import type { ComponentType } from "react";
import { useParams } from "react-router-dom";
import NotFound from "./NotFound";

const modules = import.meta.glob<{ default: ComponentType }>(
  "./finanzberatung-*.tsx",
  { eager: true },
);

const CITY_PAGES: Record<string, ComponentType> = Object.fromEntries(
  Object.entries(modules).map(([path, mod]) => [
    path.replace("./finanzberatung-", "").replace(/\.tsx$/, ""),
    mod.default,
  ]),
);

export default function CityRoute() {
  const { cityPath = "" } = useParams<{ cityPath: string }>();
  const city = cityPath.startsWith("finanzberatung-")
    ? cityPath.slice("finanzberatung-".length)
    : "";
  const Page = city ? CITY_PAGES[city] : undefined;
  if (!Page) return <NotFound />;
  return <Page />;
}
